import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Popover, PopoverVirtualElement, Typography } from '@mui/material';
import moment from 'moment';
import { VacationCalendarEvent } from '../../ModelsCalendar.types';

interface VacationEventPopoverProps {
  event: VacationCalendarEvent | null;
  anchorEl: PopoverVirtualElement | null;
  onClose: () => void;
}

const formatDateRange = (start?: Date, end?: Date): string => {
  if (!start) return '';
  const s = moment(start);
  const e = end ? moment(end).subtract(1, 'day') : s;

  if (s.isSame(e, 'day')) return s.format('MMM D, YYYY');
  if (s.isSame(e, 'month')) return `${s.format('MMM D')} – ${e.format('D, YYYY')}`;
  if (s.isSame(e, 'year')) return `${s.format('MMM D')} – ${e.format('MMM D, YYYY')}`;
  return `${s.format('MMM D, YYYY')} – ${e.format('MMM D, YYYY')}`;
};

const VacationEventPopover = ({ event, anchorEl, onClose }: VacationEventPopoverProps) => (
  <Popover
    open={!!anchorEl && !!event}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    PaperProps={{
      elevation: 3,
      sx: {
        px: 1.5,
        pt: 0.5,
        pb: 1.5,
        maxWidth: 260,
        minWidth: 200,
        borderRadius: 1.5,
        mt: '8px',
        overflow: 'visible',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: -6,
          left: 'calc(50% - 6px)',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderBottom: (theme: { palette: { background: { paper: string } } }) =>
            `6px solid ${theme.palette.background.paper}`,
        },
      },
    }}
  >
    {event && (
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
          <Typography variant="subtitle2" fontWeight={600}>
            {formatDateRange(event.start as Date | undefined, event.end as Date | undefined)}
          </Typography>
          <IconButton size="small" onClick={onClose} sx={{ ml: 1, p: 0.25 }}>
            <CloseIcon sx={{ fontSize: '0.9rem' }} />
          </IconButton>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.3 }}>
          {event.title as string}
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <CalendarMonthIcon sx={{ fontSize: '0.8rem', color: 'text.disabled' }} />
          <Typography variant="caption" color="text.disabled">
            Google Calendar
          </Typography>
        </Box>
      </Box>
    )}
  </Popover>
);

export default VacationEventPopover;
